
/**
 * Utility functions for resources
 */

/**
 * Get default image based on resource type for fallback
 * @param resourceType - The type of resource
 * @returns A URL to a default image for the given resource type
 */
export const getDefaultImageForType = (resourceType: string): string => {
  switch (resourceType) {
    case 'video': 
      return "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d";
    case 'document': 
      return "https://images.unsplash.com/photo-1649972904349-6e44c42644a7";
    case 'link':
    default: 
      return "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b";
  }
};

/**
 * Trims text to a specified length and adds ellipsis if needed
 * @param text - The text to trim
 * @param maxLength - Maximum length before trimming
 * @returns Trimmed text with ellipsis if needed
 */
export const trimText = (text: string, maxLength: number): string => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

